import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useOptionFilterContext,
  useOptionListContext,
} from "../context";

export const useSubmit = () => {
  const { setParam } = useOptionListContext();
  const { filters } = useOptionFilterContext();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as initialFilterStateProps;
    filters &&
      (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
        (key) => {
          const value = filters[key];
          if (!value) return;
          param = {
            ...param,
            [key]: value,
          };
        }
      );

    setParam(param);
  };

  return {
    onSubmit,
  };
};

// 상세모달 오픈
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmNo,
    rgSeq: props.data.opRgSeq,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};

// 수정모달 오픈
export const update = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmNo,
    rgSeq: props.data.opRgSeq,
    btnNm: props.colDef.field,
  };
  setListRowParams(params);
};

// 상태변경
export const status = (props: any) => {
  const { setListRowParams } = useListRowInfStroe.getState();

  const params = {
    no: props.data.rmNo,
    rgSeq: props.data.opRgSeq,
    btnNm: "uyn" + "_" + (props.data.uyn === "Y" ? "N" : "Y"),
  };

  setListRowParams(params);
};
